import { useMemo } from 'react';
import { Card } from 'src/components/UI/Card';
import { Blueprint } from '../../types/blog-generation-agent.types';
import BGPostCard from './BGPostCard';

interface IBGPostListProps {
  posts: Blueprint[];
  searchQuery?: string;
  onGeneratePost?: (post: Blueprint) => void;
  onViewPost?: (post: Blueprint) => void;
}

/**
 * `BGPostList` renders a list of blog post ideas filtered by searchQuery.
 * Each row shows the post title, keyword labels, description,
 * and a "Generate Post →" action.
 *
 * @component
 */
function BGPostList({
  posts,
  searchQuery = '',
  onGeneratePost,
  onViewPost
}: IBGPostListProps) {
  const filteredPosts = useMemo(() => {
    if (!searchQuery.trim()) return posts;
    const query = searchQuery.toLowerCase();
    return posts.filter(
      (post) =>
        post.title.toLowerCase().includes(query) ||
        post.primary_keywords.some((kw) => kw.toLowerCase().includes(query)) ||
        post.secondary_keywords.some((kw) =>
          kw.toLowerCase().includes(query)
        ) ||
        post.synopsis.toLowerCase().includes(query)
    );
  }, [posts, searchQuery]);

  return (
    <div className="">
      {/* Post list */}
      <div className="">
        {filteredPosts.length === 0 ? (
          <div className="py-12 text-center">
            <p className="text-[#667085] text-sm font-medium">
              No blog posts found matching your search.
            </p>
          </div>
        ) : (
          filteredPosts.map((post) => (
            <BGPostCard
              key={post._id || post.title}
              post={post}
              onGeneratePost={onGeneratePost}
              onViewPost={onViewPost}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default BGPostList;
